<template>
  <div>
    <div ref="box"></div>
  </div>
</template>

<script>
import {mxConstants, mxEdgeStyle, mxGraph} from "mxgraph-js";

export default {
  name: "TestDeptMxgraph",
  data() {
    return {
      rootNode: null,
      nodeList: [],
      lineList: [],
      config: {
        cellHeight: 60,//矩形高度
        cellWidth: 120,//矩形长度
        cellWidthRoot: 300, //根矩形长度
        cellGap: 15,//两个矩形的间隙
        levelHeight: 130,// 每个层级的高度
      },
      leafCnt: 1
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async loadDeptData() {
      let data = await this.$http('sysDepartmentService.getRootTree');
      this.rootNode = data[0]
    },
    async init() {
      await this.loadDeptData()
      if (!this.rootNode) {
        return
      }

      this.process(this.rootNode)

      this.drawImage()

    },
    process(node, offset) {
      node.children = node.children || []
      let children = node.children;
      node.rect_width = this.config.cellWidth
      if (node.level === 0) {
        node.rect_width = this.config.cellWidthRoot
      }
      node.offset = offset || 0

      if (children.length > 0) {
        let cnt = 0;
        let offset = node.offset || 0

        for (let n of children) {
          this.process(n, offset);
          cnt += n.leaf_cnt

          offset += n.leaf_cnt

          this.lineList.push({fromId: node.id, toId: n.id})
        }
        node.leaf_cnt = cnt
      } else {
        node.leaf_cnt = 1
      }

      if (children.length > 0) {
        node.x = (children[0].x + children[children.length - 1].x) / 2
      } else {
        node.x = (this.config.cellWidth + this.config.cellGap) * (node.offset + node.leaf_cnt / 2) - this.config.cellWidth / 2 + this.config.cellGap
      }

      if (children.length == 0) {
        node.x = node.x + (this.config.cellWidthRoot - this.config.cellWidth) / 2
      }

      if (node.level == 0) {
        node.x = node.x - (this.config.cellWidthRoot - this.config.cellWidth) / 2
      }

      node.y = node.level * this.config.levelHeight + 20

      this.nodeList.push(node)
    },
    drawImage() {
      let graph = new mxGraph(this.$refs.box)
      graph.setEnabled(false);

      let parent = graph.getDefaultParent();

      graph.getModel().beginUpdate();

      let style = graph.getStylesheet().getDefaultEdgeStyle();
      style[mxConstants.STYLE_EDGE] = mxEdgeStyle.TopToBottom;
      style[mxConstants.STYLE_FONTSIZE] = 16; //文字大小
      style[mxConstants.STYLE_FONTCOLOR] = "ff00ff";

      try {
        let nodeObjects = {}

        let style = 'fontSize=14;rounded=1;perimeter=ellipsePerimeter;arcSize=30';
        for (let node of this.nodeList) {
          let cell = graph.insertVertex(parent, null, node.name, node.x, node.y, node.rect_width, this.config.cellHeight, style);
          cell.id = node.id
          cell.name = node.name;

          nodeObjects[node.id] = cell;
        }

        //插入线条
        for (let line of this.lineList) {
          if (nodeObjects[line.fromId] && nodeObjects[line.toId]) {
            graph.insertEdge(parent, null, null, nodeObjects[line.fromId], nodeObjects[line.toId]);
          }
        }

      } finally {
        // Updates the display
        graph.getModel().endUpdate();
      }
    },

  }
}
</script>

<style scoped>

</style>